"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevolutionsPerHour = exports.RevolutionsPerMinute = exports.Becquerel = exports.Hertz = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var duration_1 = require("./duration");
/**
 * The derived unit for frequency ( <code>Hz</code> ).
 * A unit of frequency equal to one cycle per second. After Heinrich Rudolf Hertz (1857-1894),
 * German physicist who was the first to produce radio waves artificially.
 */
exports.Hertz = UnitDivide.dimentionlessByDuration("Hertz", uom_1.Unit.One, uom_1.BaseUnits.Second);
/**
 * The derived unit for activity of a radionuclide ( <code>Bq</code> ).
 * One becquerel is the radiation caused by one disintegration per second.
 * It is named after the French physicist, Antoine-Henri Becquerel (1852-1908).
 */
exports.Becquerel = UnitDivide.dimentionlessByDuration("Becquerel", uom_1.Unit.One, uom_1.BaseUnits.Second);
// Frequency
exports.RevolutionsPerMinute = UnitDivide.dimentionlessByDuration("RevolutionsPerMinute", uom_1.Unit.One, duration_1.Minute);
exports.RevolutionsPerHour = UnitDivide.dimentionlessByDuration("RevolutionsPerHour", uom_1.Unit.One, duration_1.Hour);
//# sourceMappingURL=frequency.js.map